import React, { ReactNode } from "react";
import {
  Box,
  CssBaseline,
  Card,
  CardContent,
} from "@mui/material";
import TitleBar from "./TitleBar";

// Define the props for the Layout component
interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        {/* Use TitleBar directly - it already has its own AppBar */}
        <TitleBar />
        
        {/* Card for the content, pushing it below the AppBar */}
        <Card
          sx={{
            margin: 2,
            marginTop: "84px",
            height: "calc(100vh - 104px)", // Adjust height to fit within viewport
          }}
        >
          <CardContent sx={{ overflowY: "auto", height: "100%" }}>
            {children}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default Layout;
